import { kGcsUserFilesPipelineBucketRef as kPipelineBucketRef } from '@/constants/constants-gcs'
import { supportedUploadFileTypes } from '@/user_files/utils/supported-upload-types'
import { kUserFilesValidatedUploadMaxFileSizeBytes } from '@/user_files/limits'

/**
 * GCS bucket for the User Files pipeline
 */
export const kGcsUserFilesPipelineBucketRef = kPipelineBucketRef

/**
 * Uppy max file size restriction
 */
export const kUppyUploadMaxFileSizeBytes = kUserFilesValidatedUploadMaxFileSizeBytes

/**
 * Allowed upload file types in the user files pipeline
 */
export const kUppyUploadAllowedFileTypes: readonly string[] = [...Object.values(supportedUploadFileTypes).flat()]

/**
 * Max number of concurrent signed XHR PUTs to cloud-backed GCS.
 */
export const kUppyUploadMaxConcurrentUploads = 3

/**
 * Keep local Storage emulator media POSTs sequential so each finalized object
 * reliably enters the backend pipeline.
 */
export const kUppyUploadMaxConcurrentEmulatorUploads = 1

/**
 * Polling interval for checking file processing status (milliseconds)
 */
export const kProcessingPollIntervalMs = 3000
